import { useCallback, useEffect, useRef, useState } from 'react';

import Common from '../../shared/Common';

const ConfirmEmailChange = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<string>('');
  const fetchIdRef = useRef(0);

  const confirmEmailChange = useCallback(async (userId: string | null, code: string | null, email: string | null) => {
    setLoading(true);
    const fetchId = ++fetchIdRef.current;

    if (fetchId === fetchIdRef.current) {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: userId,
          code: code,
          email: email,
        }),
      };
      const response = await Common.authorizedFetch('idsrv/account/confirmEmailChange', requestOptions);
      const data = await response.json();
      if (data.success) {
        setStatus('Twój adres e-mail został zmieniony.');
      } else {
        setStatus(data.errors);
      }
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const codeParam = params.get('code');
    const userIdParam = params.get('userId');
    const emailParam = params.get('email');

    confirmEmailChange(userIdParam, codeParam, emailParam);
  }, [confirmEmailChange]);

  return (
    <>
      {Common.Ui.showLoadingSpinnerFixed(loading)}
      <h1>Zmiana adresu e-mail</h1>
      <p>{status}</p>
    </>
  );
};

export default ConfirmEmailChange;
